export const EDIT_TASK_MODE = {
  TITLE: 'title',
  DESCRIPTION: 'description',
};
